import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

type AgreementProps = {
  tinyAccountIds?: string[];
  mainAccountIds?: string[];
};

type AgreementsState = {
  nonDiagnostic: AgreementProps;
};

export const initialState: AgreementsState = {
  nonDiagnostic: {},
};

const agreementsSlice = createSlice({
  name: 'agreements',
  initialState,
  reducers: {
    setNonDiagnostic(state, action: PayloadAction<AgreementProps>) {
      state.nonDiagnostic = action.payload;
    },
    addNonDiagnosticTinyAccountId(state, action: PayloadAction<string>) {
      if (!state.nonDiagnostic.tinyAccountIds)
        state.nonDiagnostic.tinyAccountIds = [];

      state.nonDiagnostic.tinyAccountIds.push(action.payload);
    },
  },
});

export const getAgreementByTinyAccountId = (
  agreementName: keyof AgreementsState,
  tinyAccountId: string,
) =>
  createSelector(
    (state: RootState) => state.agreements[agreementName],
    agreement => (agreement?.tinyAccountIds ?? []).includes(tinyAccountId),
  );

export const { setNonDiagnostic, addNonDiagnosticTinyAccountId } =
  agreementsSlice.actions;
export default agreementsSlice.reducer;
